<template>
  <el-container class="ds-exam-page ds-input-style" v-loading="examLoading">
    <el-header>
      <slot name="header"></slot>
    </el-header>
    <el-container v-if="notData">
      <div class="no-data">{{ notData }}</div>
    </el-container>
    <el-container v-else>
      <el-aside width="315px">
        <DsfVirtualScroll class="virtual-height">
          <slot name="left"></slot>
        </DsfVirtualScroll>
      </el-aside>
      <el-main>
        <DsfVirtualScroll class="virtual-height">
          <slot name="main"></slot>
        </DsfVirtualScroll>
      </el-main>
      <el-aside width="250px" style="position: relative">
        <div class="aside-right">
          <slot name="right"></slot>
        </div>
      </el-aside>
    </el-container>
  </el-container>
</template>
<script>
// 试题控件组
export default {
  name: "DsfExamLayout",
  props: {
    examLoading: {
      type: Boolean,
      default: true,
    },
    notData: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>
